// modules分成不同功能的模块
import * as types from './../mutation-types.js';
import Vue from 'vue'
var target = this
const state = {
  limit: null
}



const getters = {
    limit: state => state.limit
}

const mutations = {
  [types.GET_LIMIT](state, res) {
    state.limit = res
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/limit.js